import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useForm from '../hooks/useForm';
import { BsPower } from "react-icons/bs";
import uniminutoLogo from "../assets/uniminuto/logo-para-web.png";


const ProtectedRoute = ({ isAuthenticated, redirectPath = '/login' }) => {
    const { logout } = useForm();

    if (isAuthenticated == 'false') {
        return <Navigate to={redirectPath} replace />;
    }

    return (
        <>
            <nav className="navbar navbar-dark bg-dark">
                <img className="ms-2" src={uniminutoLogo} />
                <button
                    className="me-2 btn btn-outline-danger d-flex align-items-center"
                    onClick={logout}
                >
                    Cerrar Sesión
                    <BsPower className="ms-2" />
                </button>
            </nav>
            <Outlet />
        </>
    );
};


export default ProtectedRoute;
